import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_2xl,
  font_size_lg,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.G2ReviewBox {
    display: flex;
    flex-direction: column;

    .G2ReviewBox-title {
      font-family: ${font_family_weight_medium};
      font-size: ${font_size_2xl};
    }

    .G2ReviewBox-description {
      margin-top: ${spacing(4)};
      font-family: ${font_family_weight_regular};
      font-size: ${font_size_lg};
    }

    .G2ReviewBox-button {
      margin-top: ${spacing(6)};
    }
  }
`
